import { InputTemplateDto } from '@lmt/shared-types';
import {
  CustomCommandExecutedEventArgs,
  RichEdit,
} from '@lmt/unicorn-shared/app/common/devexpress/RichEdit/dx-richedit';
import { useEventCallback } from '@mui/material';
import { ContextMenuItem } from 'devexpress-richedit';
import i18next from 'i18next';
import { useEffect } from 'react';

const inputTemplatePrefix = 'inputTemplateId_';
const inputTemplatesId = 'inputTemplatesId';

interface Props {
  richEdit: React.MutableRefObject<RichEdit>;
  inputTemplates: InputTemplateDto[];
}

export const UpdateContextMenu: React.FC<Props> = (props) => {
  const { inputTemplates, richEdit } = props;

  const updateContextMenuHandler = useEventCallback(
    (
      s: RichEdit | undefined,
      e: CustomCommandExecutedEventArgs | undefined,
    ) => {
      if (!s || !e) {
        return;
      }
      if (e.commandName.startsWith(inputTemplatePrefix)) {
        const item = e.commandName.replace(inputTemplatePrefix, '');
        if (inputTemplates.map((x) => x.name).includes(item)) {
          const itemTemplate = inputTemplates.find((x) => x.name === item);
          if (itemTemplate) {
            s.document.insertText(s.selection.active, itemTemplate.value);
            s.selection.setSelection(
              s.selection.active + itemTemplate.value.length,
            );
          }
        }
      }
    },
  );

  useEffect(() => {
    const richEditCurrent = richEdit?.current;
    const contextMenu = richEditCurrent.contextMenu;
    const items = inputTemplates.map((template) => {
      const id = inputTemplatePrefix + template.name;
      return new ContextMenuItem(id, {
        text: template.name,
      });
    });
    contextMenu?.removeItem(inputTemplatesId);
    contextMenu?.insertItem(
      new ContextMenuItem(inputTemplatesId, {
        text: i18next.t('translation:documents.context_menu.input_templates'),
        items: items,
      }),
    );

    richEditCurrent.events.customCommandExecuted.addHandler(
      updateContextMenuHandler,
    );
    return () => {
      richEditCurrent.events.customCommandExecuted.removeHandler(
        updateContextMenuHandler,
      );
    };
  }, [inputTemplates]);

  return null;
};
